import FPageLogin from '../views/FPageLogin';

import FPageHome from '../views/FPageHome';
import FPageFinances from '../views/FPageFinances';
import FPageAdmin from '../views/FPageAdmin';
import FPageNewPassword from '../views/FPageNewPassword';

import FPageStuck from '../views/FPageStuck';
import FPageStuckProducts from '../views/FPageStuckProducts';
import FPageStuckFuels from '../views/FPageStuckFuels';

import FPageSales from '../views/FPageSales';
import FPageSalesProducts from '../views/FPageSalesProducts';
import FPageSalesFuels from '../views/FPageSalesFuels';

import FPageTecPassword from '../views/FPageTecPassword'

export default [
    {
        path: '/login',
        name: 'FPageLogin',
        component: FPageLogin
    },
    {
        path: '/',
        name: 'FPageHome',
        component: FPageHome
    },
    {
        path: '/administracao',
        name: 'FPageAdmin',
        component: FPageAdmin
    },
    {
        path: '/senha',
        name: 'FPageNewPassword',
        component: FPageNewPassword
    },
    {
        path: '/tecnico',
        name: 'FPageTecPassword',
        component: FPageTecPassword
    },
    {
        path: '/vendas',
        name: 'FPageSales',
        component: FPageSales
    },
    {
        path: '/vendas/produtos',
        name: 'FPageSalesProducts',
        component: FPageSalesProducts
    },
    {
        path: '/vendas/combustiveis',
        name: 'FPageSalesFuels',
        component: FPageSalesFuels
    },
    {
        path: '/estoque',
        name: 'FPageStuck',
        component: FPageStuck
    },
    {
        path: '/estoque/produtos',
        name: 'FPageStuckProducts',
        component: FPageStuckProducts
    },
    {
        path: '/estoque/combustiveis',
        name: 'FPageStuckFuels',
        component: FPageStuckFuels
    },
    {
        path: '/financas',
        name: 'FPageFinances',
        component: FPageFinances
    }
];
